export interface FormatCollaboratorNameAndRegistrationOptions {
  labelWhenNameMissing?: string;
}

export function formatCollaboratorNameAndRegistration(
  name?: string | null,
  registrationNumber?: string | null,
  options?: FormatCollaboratorNameAndRegistrationOptions
): string {
  const rawName = name?.trim() ?? '';
  const rawReg = registrationNumber?.trim() ?? '';
  const fallbackLabel = options?.labelWhenNameMissing?.trim() ?? '';
  const displayName = rawName || fallbackLabel;

  if (!displayName && !rawReg) {
    return '-';
  }
  if (!displayName) {
    return rawReg ? `- ${rawReg}` : '-';
  }
  if (!rawReg) {
    return displayName;
  }
  return `${displayName} - ${rawReg}`;
}
